import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        authenticated: false,
        profile: {},
        userData: {}
    },

    mutations: {
        profile (state, payload) {
            state.profile = payload;
        },
        authenticated(state, payload) {
            state.authenticated = payload
        },
        userData(state, payload) {
            state.userData = payload
        }
    }
});
